import { getPayments } from "common/services/payments.service";
import { normalize } from "common/lib/normalize";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardBody,
} from "reactstrap";
import { getSortObj } from "common/lib/tableDataOptions";
import { useProfile } from "Components/Hooks/UserHooks";
import { getYearDateRange } from "common/lib/dateUtils";
import useQueryState from "Components/Hooks/UseQueryState";

const RecentPayments = () => {
  const { userProfile } = useProfile();

  const [data, setData] = useState<any>([]);
  const [, setLoading] = useState(false);

  const [sorted, setSorted] = useState([{ id: "createdAt", desc: true }]);

  const [selectedYear] = useQueryState(
    "year",
    new Date().getFullYear().toString()
  );
  const { firstDay, lastDay } = getYearDateRange(Number(selectedYear));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sortObj = getSortObj(sorted);

        setLoading(true);
        const response = await getPayments({
          pagination: {
            page: 1,
            pageSize: 6,
          },
          populate: ["mda", "positionType", "paymentCategory", "mda.region"],
          filters: {
            agency: {
              id: userProfile?.agency?.id,
            },
            $or: [
              {
                startDate: {
                  $between: [firstDay, lastDay],
                },
              },
              {
                endDate: {
                  $between: [firstDay, lastDay],
                },
              },
            ],
          },
          sort: sortObj,
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay, sorted, userProfile?.agency?.id]);

  return (
    <Card className="card-height-100">
      <CardHeader className="align-items-center d-flex">
        {/* <h4 className="card-title mb-0 flex-grow-1">
        Contracts / Payments
      </h4> */}
        <h6 className="mb-0 fw-semibold text-uppercase flex-grow-1">
          Recent Contracts / Payments
        </h6>
        <div className="flex-shrink-0">
          <UncontrolledDropdown className="card-header-dropdown">
            <DropdownToggle tag="a" className="text-reset" role="button">
              <span className="fw-semibold text-uppercase fs-12">
                Sort by:{" "}
              </span>
              <span className="text-muted">
                Date<i className="mdi mdi-chevron-down ms-1"></i>
              </span>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                onClick={() => {
                  setSorted([{ id: "createdAt", desc: true }]);
                }}
              >
                Date
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  setSorted([{ id: "mda.name", desc: true }]);
                }}
              >
                MDA
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  setSorted([{ id: "amountPerMonth", desc: true }]);
                }}
              >
                Amount
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </CardHeader>

      <CardBody>
        <div className="table-responsive table-card">
          <table className="table table-hover table-centered align-middle table-nowrap mb-0 table-striped">
            <tbody>
              {(data || []).map((item: any, key: any) => (
                <tr key={key}>
                  <td>
                    <div
                      className="d-flex align-items-center"
                      style={{ width: "250px" }}
                    >
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm rounded p-1 me-2">
                          <div className="avatar-title bg-primary-subtle text-danger rounded fs-24">
                            <i className="ri-bank-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h5
                          className="fs-14 my-1"
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          <Link
                            to={`/payments/${item?.id}`}
                            className="text-body"
                          >
                            {item?.mda?.name || ""}
                          </Link>
                        </h5>
                        <span className="text-muted">
                          {item?.mda?.region?.name || ""}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <h5
                      className="fs-14 my-1 fw-normal"
                      style={{ width: "250px" }}
                    >
                      {item?.positionTitle || ""}
                    </h5>
                    <span className="text-muted">Position Title</span>
                  </td>
                  <td>
                    <h5 className="fs-14 my-1 fw-normal">
                      ${item?.amountPerMonth || "Not Provided"}
                    </h5>
                    <span className="text-muted">Amount / month</span>
                  </td>

                  <td>
                    <h5 className="fs-14 my-1 fw-normal">
                      {item?.postionType?.name || "Not Provided"}
                    </h5>
                    <span className="text-muted">Position Type</span>
                  </td>
                  <td>
                    <h5 className="fs-14 my-1 fw-normal">
                      {item?.paymentCategory?.name || "Not Provided"}
                    </h5>
                    <span className="text-muted">Payment Category</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
          <div className="col-sm">
            <div className="text-muted">
              Showing <span className="fw-semibold">{data?.length || 0}</span>{" "}
              of <span className="fw-semibold">{data?.length || 0}</span>{" "}
              Results
            </div>
          </div>
          <div className="col-sm-auto mt-3 mt-sm-0">
            {/* <ul className="pagination pagination-separated pagination-sm mb-0 justify-content-center">
            <li className="page-item disabled">
              <Link to="#" className="page-link">
                ←
              </Link>
            </li>
            <li className="page-item">
              <Link to="#" className="page-link">
                1
              </Link>
            </li>
            <li className="page-item active">
              <Link to="#" className="page-link">
                2
              </Link>
            </li>
            <li className="page-item">
              <Link to="#" className="page-link">
                3
              </Link>
            </li>
            <li className="page-item">
              <Link to="#" className="page-link">
                →
              </Link>
            </li>
          </ul> */}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default RecentPayments;
